export const FETCH_VIDEO_COUNT = 10;
export const MAX_STORE_KEYWORD_COUNT = 3;
export const MAX_SAVED_VIDEO_COUNT = 100;

export const EMPTY_VIDEO_MSG = "영상이 없습니다.";

export const TO_WATCH = "toWatch";
export const WATCHED = "watched";
export const LIKED = "liked";

export const IS_WATCHED = "isWatched";
export const IS_LIKED = "isLiked";
export const DELETE = "delete";
